import React from 'react';

import {
    Tabs,
    TabsContent,
    TabsList,
    TabsTrigger,

} from "src/components/ui/tabs"

import {
    AccountDetails,
    Subscriptions,
    Addresses,
    PaymentMethods,
    LeftArrowIcon,
    Favorites
} from '../components';
import { Link } from 'react-router-dom';
const TabsData = [
    { value: "account-details", label: "Account Details" },
    { value: "subscriptions", label: "Subscriptions" },
    { value: "addresses", label: "Addresses" },
    { value: "payment-methods", label: "Payment Methods" },
    // { value: "favorites", label: "Favorites" },
  ];
function Account() {
    return (
        <>
            <div className='w-full px-6 py-4 md:px-12'>
                <Link className="flex items-center gap-3 pb-4 md:hidden group" to='/'>
                    <div className="flex items-center justify-center rounded-full bg-gold-50 md:h-11 md:w-11 h-9 w-9">
                        <LeftArrowIcon className="text-gray-700 group-hover:text-gold-500" />
                    </div>
                    <h5 className="font-normal text-base leading-5.5 text-gray-600 group-hover:text-gold-500" >Back</h5>
                </Link>
                <div className='pb-6'>
                    <h1 className='text-2xl font-bold capitalize text-primary-0'>my account</h1>
                </div>
                <div className=''>
                    {/* Tabs usign a shadcn start */}
                    <Tabs defaultValue="account-details" className="bg-white-50">
                        <TabsList className="relative flex flex-col justify-around w-full h-auto border-gray-100 rounded-none border-b-1 md:flex-row bg-white-50">
                            <div className="flex flex-row w-full overflow-x-auto md:items-center scrollbar-hide xl:overflow-visible">
                                {TabsData.map((tab) => (
                                    <TabsTrigger
                                        key={tab.value}
                                        value={tab.value}
                                        className=" lg:-mb-[5px] p-4 text-gray-400 text-base leading-5 font-semibold cursor-pointer font-redhat !shadow-none border-b-1 border-transparent data-[state=active]:text-gold-500 data-[state=active]:border-gold-500 rounded-none whitespace-nowrap"
                                    >
                                        {tab.label}
                                    </TabsTrigger>
                                ))}
                            </div>
                        </TabsList>
                        {TabsData.map((tab) => (
                            
                            <TabsContent value={tab.value} className="w-full max-w-full mt-0 font-normal leading-7 text-left text-gray-900 font-redhat text-18">
                               {(() => {
                                    switch (tab.value) {
                                        case "account-details":
                                            return <AccountDetails />;
                                        case "subscriptions":
                                            return <Subscriptions />;
                                        case "addresses":
                                            return <Addresses />;
                                        case "payment-methods":
                                            return <PaymentMethods />;
                                        case "favorites":
                                            return <Favorites />;
                                        default:
                                            return <p>No content available</p>;
                                    }
                                })()}
                            </TabsContent>
                        ))}
                    </Tabs>
                </div>
            </div>
        </>
    );
}
export default Account;